import { footerColumns } from "@/mocks/home";

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="mx-auto w-full max-w-shell px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-8">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-flashlight-fill text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">黑料平台</span>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-background-200/70">
              一个把爆料、吃瓜与深扒放在一起看的资讯平台。功能、内容板块、服务与玩法机制，都在官网首页说清楚。
            </p>
            <div className="mt-6 flex items-center gap-3">
              {["ri-wechat-line", "ri-weibo-line", "ri-mail-line"].map((icon) => (
                <a
                  key={icon}
                  href="#top"
                  aria-label="平台社交渠道"
                  className="flex h-9 w-9 items-center justify-center rounded-md border border-background-100/20 text-background-200/80 transition-colors hover:border-background-50 hover:text-background-50"
                >
                  <i className={`${icon} text-lg`} />
                </a>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-4 lg:col-span-8">
            {footerColumns.map((column) => (
              <div key={column.title}>
                <h4 className="font-heading text-sm font-bold text-background-50">
                  <a href="#top" className="transition-colors hover:text-accent-400">
                    {column.title}
                  </a>
                </h4>
                <ul className="mt-4 space-y-3">
                  {column.links.map((link) => (
                    <li key={link}>
                      <a
                        href="#top"
                        className="text-sm text-background-200/70 transition-colors hover:text-background-50"
                      >
                        {link}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-background-100/15 pt-6 text-xs text-background-200/60 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 黑料平台 · 本站为内容展示页面，信息请以官方发布为准。</p>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
            <a href="#faq" className="transition-colors hover:text-background-50">
              内容规范
            </a>
            <a href="#faq" className="transition-colors hover:text-background-50">
              纠错通道
            </a>
            <a href="#faq" className="transition-colors hover:text-background-50">
              常见问题
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}